import React, { useState } from 'react';
import { BookOpen, Lock, ClockCounterClockwise, X } from 'phosphor-react';

const OnboardingFlow = ({ onComplete }) => {
  const [step, setStep] = useState(0);

  const steps = [
    {
      icon: <Lock size={32} weight="duotone" className="text-primary" />,
      title: "Private by Design",
      description: "Your conversations are encrypted on your device using your passcode. Your messages are sent to an AI service to generate Vela's responses, but nothing you share is stored on our servers."
    },
    {
      icon: <BookOpen size={32} weight="duotone" className="text-secondary" />,
      title: "Saved Like a Diary",
      description: "Your conversations are saved like a private diary — only you decide what matters. Nothing is saved unless you tap Save to Diary, and only you can decrypt saved entries."
    },
    {
      icon: <ClockCounterClockwise size={32} weight="duotone" className="text-primary" />,
      title: "Find Past Conversations",
      description: "Access your conversation history anytime through your diary. Each session is saved with a summary to help you reflect."
    }
  ];

  const currentStep = steps[step];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      onComplete();
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  return (
    <div className="fixed inset-0 bg-stone-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-soft relative">
        <button
          onClick={handleSkip}
          className="absolute top-6 right-6 text-stone-400 hover:text-stone-600 transition-colors"
          data-testid="skip-onboarding"
        >
          <X size={24} />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            {currentStep.icon}
          </div>
          <h2 className="text-2xl font-serif font-semibold text-stone-800 mb-3">
            {currentStep.title}
          </h2>
          <p className="text-stone-600 leading-relaxed">
            {currentStep.description}
          </p>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center gap-2 mb-6">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={`w-2 h-2 rounded-full transition-all ${
                idx === step ? 'bg-primary w-6' : 'bg-stone-300'
              }`}
            />
          ))}
        </div>

        <button
          onClick={handleNext}
          className="w-full bg-primary text-white rounded-full px-8 py-4 font-medium hover:shadow-soft transition-all duration-300 active:scale-95"
          data-testid="onboarding-next"
        >
          {step < steps.length - 1 ? 'Next' : 'Get Started'}
        </button>

        <button
          onClick={handleSkip}
          className="w-full text-stone-500 hover:text-stone-700 text-sm mt-3 transition-colors"
          data-testid="onboarding-skip"
        >
          Skip
        </button>
      </div>
    </div>
  );
};

export default OnboardingFlow;
